import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  userSelectMarketerCreditSubsetNumberChart:
    "userSelectMarketerCreditSubsetNumberChart [Action]",
  userSelectMarketerCreditSubsetNumberChartLoading:
    "userSelectMarketerCreditSubsetNumberChartLoading [Action]",
  userSelectMarketerCreditSubsetNumberChartAsync:
    "userSelectMarketerCreditSubsetNumberChartAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const user_select_marketer_credit_subset_number_chart_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.userSelectMarketerCreditSubsetNumberChart:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.userSelectMarketerCreditSubsetNumberChartLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.userSelectMarketerCreditSubsetNumberChartLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "marketer",
    method_type: "user_select_marketer_credit_subset_number_chart",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.userSelectMarketerCreditSubsetNumberChart,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.userSelectMarketerCreditSubsetNumberChartLoading,
      payload: false,
    });
  }
}

export function* userSelectMarketerCreditSubsetNumberChart() {
  yield takeLatest(
    actionTypes.userSelectMarketerCreditSubsetNumberChartAsync,
    handleWorker
  );
}
